import { useMemo } from 'react';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

/**
 * Returns the list of federation versions that are available to use.
 * @param includeFedNext - Whether to include the FedNext version. Default is false.
 * @param includeFed1 - Whether to include the Fed 1.x versions. Default is true.
 * @returns The list of federation versions.
 */
export const useGetSortedFederationVersions = ({
  includeFed1 = true,
  includeFedNext = false,
}: {
  includeFedNext?: boolean;
  includeFed1?: boolean;
}) => {
  return useMemo(
    () =>
      Object.values(GraphQLTypes.BuildPipelineTrack).filter((track) => {
        if (track.includes('FED_1')) {
          return includeFed1;
        }
        if (track === GraphQLTypes.BuildPipelineTrack.FED_NEXT) {
          return includeFedNext;
        }
        return true;
      }),
    [includeFedNext, includeFed1],
  ).reverse();
};
